import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    // Track if menu is open
    this.isOpen = false
    
    // Use a small delay to ensure click outside handler doesn't interfere with toggle
    // We'll use requestAnimationFrame to defer the click outside check
    this.boundHandleClickOutside = this.handleClickOutside.bind(this)
    
    // Close dropdown on escape key
    this.boundHandleEscape = this.handleEscape.bind(this)
    document.addEventListener("keydown", this.boundHandleEscape)
  }

  toggle(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    
    const isHidden = this.menuTarget.classList.contains("hidden")
    
    // Close all other dropdowns first (for mobile, ensure only one is open)
    document.querySelectorAll('[data-dropdown-target="menu"]').forEach(menu => {
      if (menu !== this.menuTarget) {
        menu.classList.add("hidden")
      }
    })
    
    // Remove any existing click listener before adding a new one
    if (this.clickListenerAttached) {
      document.removeEventListener("click", this.boundHandleClickOutside, true)
      this.clickListenerAttached = false
    }
    
    if (isHidden) {
      this.show()
      // Add click outside listener after showing (with a small delay to avoid immediate close)
      setTimeout(() => {
        if (this.isOpen) {
          document.addEventListener("click", this.boundHandleClickOutside, true)
          this.clickListenerAttached = true
        }
      }, 10)
    } else {
      this.hide()
    }
  }

  hide() {
    this.menuTarget.classList.add("hidden")
    this.isOpen = false
    // Remove click listener when hiding
    if (this.clickListenerAttached) {
      document.removeEventListener("click", this.boundHandleClickOutside, true)
      this.clickListenerAttached = false
    }
  }

  show() {
    this.menuTarget.classList.remove("hidden")
    this.isOpen = true
  }

  disconnect() {
    if (this.clickListenerAttached) {
      document.removeEventListener("click", this.boundHandleClickOutside, true)
    }
    document.removeEventListener("keydown", this.boundHandleEscape)
  }

  handleClickOutside(event) {
    // Don't close if clicking inside the dropdown element (button or menu)
    if (this.isOpen && !this.element.contains(event.target)) {
      this.hide()
    }
  }

  handleEscape(event) {
    if (event.key === "Escape" && this.isOpen) {
      this.hide()
    }
  }
}
